import { jbColors } from 'theme/jbColors';
import palette from 'theme/palette';

export const typography = {
  fontFamily: 'Verlag, Helvetica, Arial, sans-serif',
  fontSize: 13,
  color: palette.primary.main,
  h1: {
    color: palette.primary.main,
    fontWeight: 400,
    fontSize: '1.6rem',
    lineHeight: 1.48,
    letterSpacing: '0.8px',
    textTransform: 'uppercase' as const,
  },
  h2: {
    color: palette.primary.main,
    fontWeight: 300,
    fontSize: '1.8rem',
    letterSpacing: '-0.24px',
    lineHeight: '2rem',
  },
  h3: {
    color: palette.primary.main,
    fontWeight: 400,
    fontSize: '1.5rem',
    letterSpacing: '-0.06px',
    lineHeight: '1.75rem',
  },
  h4: {
    color: palette.primary.main,
    fontWeight: 300,
    fontSize: '1.25rem',
    letterSpacing: '-0.06px',
    lineHeight: '1.5rem',
  },
  h5: {
    color: palette.primary.main,
    fontWeight: 300,
    fontSize: '1rem',
    letterSpacing: '-0.05px',
    lineHeight: '1.25rem',
  },
  h6: {
    color: palette.primary.main,
    fontWeight: 700,
    fontSize: '0.813rem',
    letterSpacing: '0.16px',
    lineHeight: '1.125rem',
  },
  subtitle1: {
    color: palette.primary.main,
    fontWeight: 400,
    fontSize: '1rem',
    letterSpacing: '-0.05px',
    lineHeight: '1.25rem',
  },
  subtitle2: {
    color: palette.primary.main,
    fontWeight: 400,
    fontSize: '0.8125rem',
    letterSpacing: '-0.05px',
    lineHeight: '0.94rem',
  },
  body1: {
    color: 'black',
    fontSize: '0.8125rem',
    lineHeight: '0.94rem',
    letterSpacing: '0.4px',
    fontWeight: 400,
  },
  body2: {
    color: 'black',
    fontSize: '0.75rem',
    letterSpacing: '0.4px',
    lineHeight: '1rem',
    fontWeight: 400,
  },
  button: {
    color: palette.primary.main,
    fontSize: '0.8125rem',
    textTransform: 'none' as const,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1rem',
    letterSpacing: '0.16px',
  },
  caption: {
    color: jbColors.support.greenSmoke[80],
    fontWeight: 700,
    fontSize: '0.75rem',
    letterSpacing: '-0.05px',
    lineHeight: '1.25rem',
  },
  overline: {
    fontSize: '0.7rem',
    fontWeight: 400,
  },
};
